import React, { Component } from 'react';
import { connect } from 'react-redux';
import Broker from "../../components/Broker/broker";
import {
    changeBroker,
    changeBrokerState,
    createBroker,
    getBrokerById,
    unlockBroker,
    updateBrokerById
} from "../../actions/broker";
import {isEmail, isPhone} from "../../helpers/functions";
import {getBrokerFirms} from "../../actions/brokerFirms";
import _ from 'lodash';
import {unlockAragUser} from "../../actions/user";

class BrokerHOC extends Component {

    componentDidMount(){
        this.props.getBrokerFirms();
        if(this.props.match.params.id){
            this.props.getBrokerById({id: this.props.match.params.id})
        }
    }

    validateForm = () => {
        const errors = [];
        if (!this.props.broker.brokerFirmId) {
            errors.push('Agent cannot be blank');
        }
        if (!this.props.broker.forename) {
            errors.push('Forename cannot be blank');
        }
        if (!this.props.broker.surname) {
            errors.push('Surname cannot be blank');
        }
        if (!this.props.broker.email) {
            errors.push('Email cannot be blank');
        }
        if (!this.props.broker.username) {
            errors.push('Username cannot be blank');
        }
        if (this.props.broker.email && !isEmail(this.props.broker.email)) {
            errors.push('Email is not valid.')
        }
        if (this.props.broker.ccEmailAddress && !isEmail(this.props.broker.ccEmailAddress)) {
            errors.push('CC Email is not valid.')
        }
        if (this.props.broker.telephone1 && !isPhone(this.props.broker.telephone1)) {
            errors.push('Telephone Number 1 is not valid.')
        }
        if (this.props.broker.telephone2 && !isPhone(this.props.broker.telephone2)) {
            errors.push('Telephone Number 2 is not valid.')
        }
        return errors;
    };

    handleSubmit = (evt) => {
        evt.preventDefault();
        const errors = this.validateForm();
        if(errors.length > 0){
            this.props.changeBrokerState({
                key: 'formErrors',
                value: errors
            });
            return false
        }
        const userBrokerFirm = this.getBrokerFirmById(this.props.broker.brokerFirmId);
        const sendBody = {
            id: this.props.broker.id,
            userId: this.props.broker.userId,
            username: this.props.broker.username,
            email: this.props.broker.email,
            forename: this.props.broker.forename,
            surname: this.props.broker.surname,
            ccEmail: this.props.broker.ccEmailAddress,
            lawsysId: this.props.broker.brokerFirmId,
            telephone1: this.props.broker.telephone1,
            telephone1Description: this.props.broker.telephone1Description,
            telephone2: this.props.broker.telephone2,
            telephone2Description: this.props.broker.telephone2Description,
            addressLine1: userBrokerFirm?userBrokerFirm.address:null,
        };
        if(this.props.match.params.id){
            this.props.updateBrokerById({
                sendBody: sendBody
            })
        } else {
            this.props.createBroker({
                sendBody: sendBody
            })
        }

    };

    getBrokerFirmById = (id) => {
        return _.find(this.props.brokerFirms, brokerFirm => {return brokerFirm.id.toString() === id});
    };

    onUnlockBroker = () => {
        this.props.unlockBroker({
            brokerId: this.props.broker.userId
        })
    };

    render(){
        return(
            <Broker
                {...this.props}
                onUnlockBroker={this.onUnlockBroker}
                unlockingUser={this.props.unlockingUser}
                unlockErrorMessage={this.props.unlockErrorMessage}
                handleSubmit={this.handleSubmit}
                cancelSubmit={this.props.history.goBack}
                userBrokerFirm={this.getBrokerFirmById(this.props.broker.brokerFirmId)}
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        broker: state.broker.broker,
        unlockingUser: state.broker.unlockingUser,
        unlockErrorMessage: state.broker.unlockErrorMessage,
        formErrors: state.broker.formErrors,
        fetchingBroker: state.broker.fetching,
        loading: state.broker.posting || state.broker.patching,
        brokerFirms: state.brokerFirms.brokerFirms,
        formSuccessMsg: state.broker.formSuccessMsg,
        generalError: state.broker.generalError
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeBroker: (payload) => {
            dispatch(changeBroker(payload))
        },
        createBroker: (payload) => {
            dispatch(createBroker(payload))
        },
        changeBrokerState: (payload) => {
            dispatch(changeBrokerState(payload))
        },
        getBrokerById: (payload) => {
            dispatch(getBrokerById(payload))
        },
        updateBrokerById: (payload) => {
            dispatch(updateBrokerById(payload))
        },
        getBrokerFirms: (payload) => {
            dispatch(getBrokerFirms(payload))
        },
        unlockBroker: (payload) => {
            dispatch(unlockBroker(payload))
        },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(BrokerHOC)